/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export const verticalCollapse = (element, expand) => {
  if (expand) {
    element.style.height = `${element.scrollHeight}px`;
  } else {
    element.style.height = '0px';
  }
};
